import { gsap } from 'gsap/dist/gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/dist/ScrollToPlugin';

import Layout from '@/layouts/layout';
import useFoucFix from '@/hooks/useFoucFix';
import bynk from '@/utils/bynk';

import '@/styles/globals.scss';
import 'react-international-phone/style.css';
import '@/components/Reclamo/index.scss';
import '@/components/SeguiTuEnvio/EstadoDelEnvio/Timeline/index.css';
import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { GoogleMapsProvider } from '@/components/GoogleMaps/GoogleMapsProvider';
import LocaleContext from '@/context/LocaleContext';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

export default function App({ Component, pageProps }) {
  const router = useRouter();
  const locale = pageProps.locale || router.locale || router.defaultLocale;

  if (process.env.NEXT_PUBLIC_DOMAIN === 'production') {
    bynk();
  }
  useFoucFix();

  // Next guarda la primera entrada del historial con el locale con el que arrancó el router, que en
  // .uy/.pe es es-AR (ver context/LocaleContext.jsx): sin esto, "Atrás" hacia esa entrada redirige a
  // hopenvios.com.ar. Next lee state.options.locale después de este callback.
  useEffect(() => {
    router.beforePopState((state) => {
      state.options.locale = locale;
      return true;
    });
  }, [router, locale]);

  return (
    <LocaleContext.Provider value={locale}>
      <Layout locale={locale} hideNavBar={pageProps.hideNavBar}>
      <GoogleMapsProvider>
        <Component {...pageProps} />
        </GoogleMapsProvider>
      </Layout>
    </LocaleContext.Provider>
  );
}
